import api from './index';

const basePath = (entityConfigId) => `/api/v1/entity_configurations/${entityConfigId}`;

export default {
  updateHiddenColumns(entityConfigId, hiddenColumns) {
    return api({
      method: 'patch',
      data: { hiddenColumns },
      url: `${basePath(entityConfigId)}`,
    });
  },
  updateMovementsNumber(entityConfigId, movementsNumber) {
    return api({
      method: 'patch',
      data: { movementsNumber },
      url: `${basePath(entityConfigId)}`,
    });
  },
  addExtraColumn(entityConfigId, extraColumnSchema) {
    return api({
      method: 'post',
      data: extraColumnSchema,
      url: `${basePath(entityConfigId)}/extra_columns`,
    });
  },
  deleteExtraColumn(entityConfigId, extraColumnName) {
    return api({
      method: 'delete',
      data: extraColumnName,
      url: `${basePath(entityConfigId)}/extra_columns`,
    });
  },
  updateExtraColumn(entityConfigId, originalColumnName, extraColumnSchema) {
    return api({
      method: 'patch',
      data: { originalColumnName, extraColumnSchema },
      url: `${basePath(entityConfigId)}/extra_columns`,
    });
  },
  enableFilterExtraColumn(entityConfigId, extraColumnName, enableFilter) {
    return api({
      method: 'put',
      data: { extraColumnName, enableFilter },
      url: `${basePath(entityConfigId)}/extra_columns_filters`,
    });
  },
};
